import React from 'react';

const UserMgt = () => {
    return (
        <div>UserMgt</div>
    )
}

export default UserMgt;